import excelerate from '../assets/my_projects/excelerate.png'
import karmachari from '../assets/my_projects/karmachari.png'
import neurotech from '../assets/my_projects/neurotech.png'
import voteWave from '../assets/my_projects/voteWave.png'
import codehall from '../assets/my_projects/codehall.png'
import mainproject from '../assets/my_projects/mainproject.png'
import rootflo from '../assets/my_projects/rootflo.png'
export const myworks = [
  {
    id:1,
    image: rootflo,
    description:"Recognized as one of the Top 10 Fintechs leveraging AI to serve Bharat at the Global Fintech Fest 2025, organized by NPCI and NVIDIA.Proud to represent Rootflo.ai and showcase our innovations in the Bharat AI Experience Zone.",
    url:"https://www.rootflo.ai/"

  },
  {
    id:2,
    image: codehall,
    heading:"CodeHall",
    description:"OCP is the company's internal platform where I developed the scheduling module for interviews and meetings, integrating it with Google Calendar using FastAPI, React.js, MySQL, and Docker.",
    url:"https://www.codehall.in/"
  },
  {
    id: 3,
    image: karmachari,
    heading:"Labour Commissionerate – Government of Kerala",
    description: "Developed a job portal that simplifies recruitment and benefits students and schools. It verifies job postings and ensures their authenticity. Users can apply easily, while administrators have access to statistics and necessary functions for efficient management.",
    url:"https://karmachari.lc.kerala.gov.in/"
    
  },
    {
      id: 4,
      image: excelerate,
      heading:"Excel",
      description: "Excel is India’s second largest techno-managerial festival hosted by Govt. Model Engineering College, Kochi.",
      url:"https://ca.excelmec.org/"
    },
    
    {
      id: 5,
      image: neurotech,
      heading:"NT Labs Pvt Ltd",
      description: "Created a web application offering brainmapping functionalities, enabling users to explore, visualize, and analyze brain-related data and activities",
      url:"https://www.neurotech.in/"
    },
    {
      id: 6,
      image: mainproject,
      heading:"Student Monitoring Sysytem",
      description: "Developed a student monitoring system using CNN, TensorFlow, and Streamlit to assess classroom understanding through emotion recognition, achieving 76% accuracy and improving real-time feedback on student engagement.",
      url:"https://github.com/jacobsanosh/AI-StudMon"
    },
    {
      id: 7,
      image: voteWave,
      heading:"VoteWave",
      description: "Developed AI-based voting system offers an online platform enabling users to cast their votes securely, incorporating face verification and OTP authentication for a seamless and trustworthy election experience",
      url:"https://github.com/jacobsanosh/AI-based-evm-frontend"
    }
  ];
  
  export default myworks;
  